import * as React from 'react';
import { VideoPlayer } from '@app/components/atm.video-player';
import { Modal } from '@atomic/obj.modal/modal.component';
export var VideoModal = function (_a) {
    var opened = _a.opened, small = _a.small, onClose = _a.onClose, closeOnOutsideClick = _a.closeOnOutsideClick, videoURL = _a.videoURL;
    return (React.createElement(Modal, { opened: opened, small: small, onClose: onClose, closeOnOutsideClick: closeOnOutsideClick },
        React.createElement(VideoPlayer, { videoUrl: videoURL })));
};
